import React from "react"
import AboutCard from "../about/AboutCard"
import Hblog from "./Hblog"
import HAbout from "./HAbout"
import Hero from "./hero/Hero"
import Hprice from "./Hprice"
import Testimonal from "./testimonal/Testimonal"
import About from "./Ab"

const Home = () => {
  return (
    <>
      <Hero />
      <About />

      {/* <AboutCard /> */}
      <HAbout />
      <Testimonal />
      {/* <Hblog /> */}
      {/* <Hprice /> */}
    </>
  )
}

export default Home